// Cycle 274: map raw auth error codes/details to human-readable text.
// The apiClient surfaces the server's `detail` verbatim as error.message,
// so a 403 `signup_not_invited` arrives here as that string. Used by both
// the email register path (useAuth.signUp) and the OAuth path
// (AuthMethods), so invite-only signups read the same friendly line.

export function friendlyAuthError(message: string | undefined | null): string {
  const m = (message || "").trim();
  if (!m) return "Something went wrong. Please try again.";
  if (m.includes("signup_not_invited")) {
    return "Sugar Alarm is invite-only right now. Ask the team to add your email address, then try again.";
  }
  return m;
}
